import { render, staticRenderFns } from "./ruleView.vue?vue&type=template&id=7ca01db6&scoped=true&"
import script from "./ruleView.vue?vue&type=script&lang=js&"
export * from "./ruleView.vue?vue&type=script&lang=js&"
import style0 from "./ruleView.vue?vue&type=style&index=0&id=7ca01db6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca01db6",
  null
  
)

export default component.exports